import { BusinessLoginState, BusinessLoginMutations } from './types';

export default function mutationFactory(state: BusinessLoginState): BusinessLoginMutations {
    function MUTATION_SET_BUSINESS_LOGIN(businessId: string, language: string = "cs", operation: any = null, addonId: string | null = null) {
        state.businessId = businessId;
        state.language = language;
        state.operation = operation;
        state.addonId = addonId;
        state.error = null;
        console.log('MUTATION_SET_BUSINESS_LOGIN', state);
    }

    function MUTATION_CLEAR_BUSINESS_LOGIN() {
        state.businessId = null;
        state.language = null;
        state.operation = null;
        state.addonId = null;
        state.isLoading = false;
        state.error = null;
        console.log('MUTATION_CLEAR_BUSINESS_LOGIN', state);
    }

    function MUTATION_SET_LOADING(loading: boolean) {
        state.isLoading = loading;
    }

    function MUTATION_SET_ERROR(error: string | null) {
        state.error = error;
        state.isLoading = false;
    }

    return {
        MUTATION_SET_BUSINESS_LOGIN,
        MUTATION_CLEAR_BUSINESS_LOGIN,
        MUTATION_SET_LOADING,
        MUTATION_SET_ERROR
    }
}
